<template>
  <div>
    <ele-pro-table
      ref="table"
      :datasource="url"
      :columns="columns"
      :where="where"
      height="calc(100vh - 261px)"
      tool-class="ele-toolbar-form">
      <template slot="toolbar">
        <el-form
          :model="where"
          class="ele-form-search"
          size="small"
          @keyup.enter.native="reload"
          @submit.native.prevent>
          <el-row :gutter="10">
            <el-col :md="8">
              <el-form-item>
                <el-input v-model="where.name" placeholder="参数名称" clearable size="small" />
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item>
                <el-input v-model="where.code" placeholder="参数编码" clearable size="small" />
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item>
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  class="ele-btn-icon"
                  size="small"
                  @click="reload">查询
                </el-button>
                <el-button
                  v-if="permission.includes('sys:website:add')"
                  type="primary"
                  icon="el-icon-plus"
                  class="ele-btn-icon"
                  size="small"
                  @click="openEdit(null)">添加
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
      <template slot="value" slot-scope="{ row }">
        <span>{{ formatValue(row) }}</span>
      </template>
      <template slot="status" slot-scope="{ row }">
        <el-switch
          v-model="row.status"
          :active-value="1"
          :inactive-value="2"
          @change="editStatus(row)" />
      </template>
      <template slot="action" slot-scope="{ row }">
        <el-link
          v-if="permission.includes('sys:website:edit')"
          type="primary"
          :underline="false"
          icon="el-icon-edit"
          @click="openEdit(row)">编辑
        </el-link>
        <el-popconfirm
          v-if="permission.includes('sys:website:delete')"
          class="ele-action"
          title="确定要删除此参数吗？"
          @confirm="remove(row)">
          <el-link slot="reference" type="danger" :underline="false" icon="el-icon-delete">删除</el-link>
        </el-popconfirm>
      </template>
    </ele-pro-table>
    <param-data-edit
      :visible.sync="showEdit"
      :data="current"
      :config-id="configId"
      @done="reload" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ParamDataEdit from './param-data-edit';

export default {
  name: 'ParamData',
  components: { ParamDataEdit },
  props: {
    configId: Number
  },
  computed: {
    ...mapGetters(['permission'])
  },
  data() {
    return {
      url: '/configdata/index',
      columns: [
        { columnKey: 'index', type: 'index', label: '序号', width: 60, align: 'center', fixed: 'left' },
        { prop: 'title', label: '参数名称', minWidth: 140, align: 'center', showOverflowTooltip: true },
        { prop: 'code', label: '参数编码', minWidth: 140, align: 'center', showOverflowTooltip: true },
        { prop: 'type', label: '类型', width: 100, align: 'center' },
        { prop: 'value', label: '参数值', minWidth: 160, align: 'center', showOverflowTooltip: true, slot: 'value' },
        { prop: 'sort', label: '排序', width: 80, align: 'center' },
        { prop: 'status', label: '状态', width: 90, align: 'center', slot: 'status' },
        { prop: 'note', label: '备注', minWidth: 140, align: 'center', showOverflowTooltip: true },
        {
          columnKey: 'action',
          label: '操作',
          width: 130,
          align: 'center',
          resizable: false,
          slot: 'action',
          fixed: 'right'
        }
      ],
      where: {
        configId: this.configId,
        name: '',
        code: ''
      },
      current: null,
      showEdit: false
    };
  },
  watch: {
    configId(val) {
      this.where.configId = val;
      this.reload();
    }
  },
  methods: {
    formatValue(row) {
      if (!row) {
        return '';
      }
      if (row.type === 'password') {
        return row.value ? '********' : '';
      }
      if (row.type === 'switch') {
        const on = ['1', 'true', 'on', 'yes'].includes(String(row.value).toLowerCase());
        return on ? '开启' : '关闭';
      }
      return row.value;
    },
    reload() {
      this.$refs.table.reload({ where: this.where });
    },
    openEdit(row) {
      this.current = row;
      this.showEdit = true;
    },
    remove(row) {
      const loading = this.$loading({ lock: true });
      this.$http.post('/configdata/delete', { id: row.id }).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          this.reload();
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        this.$message.error(e.message);
      });
    },
    editStatus(row) {
      const loading = this.$loading({ lock: true });
      this.$http.post('/configdata/status', { id: row.id, status: row.status }).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
        } else {
          row.status = row.status === 1 ? 2 : 1;
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        row.status = row.status === 1 ? 2 : 1;
        this.$message.error(e.message);
      });
    }
  }
};
</script>
